import queryString from "query-string";
import moment from "moment";

const ObjectsToCsv = require('objects-to-csv');

export const validateEmail = (email) => {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
};

export const TagKeyCodes = {
    TAB: 9,
    ENTER: 13,
    COMMA: 188,
};

export const tagDelimiters = [TagKeyCodes.TAB, TagKeyCodes.ENTER, TagKeyCodes.COMMA];

export const addressComponentsFromGoogle = (gObj) => {
    let addr = {
        fullAddress: gObj.formatted_address,
        googleId: gObj.place_id,
        address1: '',
        address2: '',
        city: '',
        state: '',
        postalCode: '',
        country: '',
    };

    if (gObj && gObj.address_components && gObj.address_components.length > 0) {
        for (let g = 0; g < gObj.address_components.length; g++) {
            const part = gObj.address_components[g];
            if (part.types && part.types.length > 0) {
                switch (part.types[0]) {
                    case 'street_number':
                        addr.address1 = part.long_name;
                        break;
                    case 'route':
                        addr.address1 += ' ' + part.long_name;
                        break;
                    case 'locality':
                        addr.city = part.long_name;
                        break;
                    case 'administrative_area_level_1':
                        addr.state = part.short_name;
                        break;
                    case 'country':
                        addr.country = part.short_name;
                        break;
                    case 'postal_code':
                        addr.postalCode = part.short_name;
                        break;
                    case 'postal_code_suffix':
                        addr.postalCode += '-' + part.short_name;
                        break;
                    default:
                        break;
                }
            }
        }
    }
    return addr;
};

export const getQueryObj = () => {
    if (window.location.search) return queryString.parse(window.location.search);
    return null;
}

export const amInIFrame = () => {
    return (window.parent.window !== window)
}

export const amInPopup = () => {
    let inPopup = window.location.pathname.startsWith('/popup/');

    if (!inPopup && amInIFrame() && window.location.pathname.startsWith('/sign-')) inPopup = true;

    if (!inPopup) {
        const queryObj = getQueryObj();
        if (queryObj && queryObj.popup) inPopup = true;
    }

    // if (amInIFrame() && window.location.pathname.indexOf('/sign-') > -1) inPopup = true;

    return inPopup;
}

const mouseClickEvents = ['mousedown', 'click', 'mouseup'];

export const simulateMouseClick = (element) => {
    if (element) {
        mouseClickEvents.forEach(mouseEventType =>
            element.dispatchEvent(
                new MouseEvent(mouseEventType, {
                    view: window,
                    bubbles: true,
                    cancelable: true,
                    buttons: 1
                })
            )
        );
    }
}

export const tellParentContentHeight = (node, queryObj) => {
    if (node !== null && queryObj && queryObj.selectionUrl) {
        tellParentMessage({contentHeight: node.scrollHeight})
    }
}

export const tellParentMessage = (message, queryObj) => {
    if (queryObj && queryObj.selectionUrl) {
        window.parent.postMessage(message, queryObj.selectionUrl);
    }
}

export const tellParentURLMessage = (message, url) => {
    if (url) {
        window.parent.postMessage(message, url);
    }
}

export const camelToSnakeCase = str => str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);

const convertArrayToCommRecord = (commType, arr, primary, others) => {
    let counters = {};
    let fields = {};
    for (let a = 0; a < arr.length; a++) {
        const commObj = arr[a];

        let arrayRowPrefix;
        let commObjType = commObj[commType + 'Type'];
        if (commObj.primary && primary) {
            arrayRowPrefix = 'primary';
        } else if (others) {
            if (!counters[commObjType]) {
                counters[commObjType] = 1;
            } else {
                counters[commObjType]++;
            }
            arrayRowPrefix = commObjType + '_' + counters[commObjType];
        }

        if (arrayRowPrefix) {
            Object.keys(commObj).forEach((commObjKey) => {
                if (['createdAt', 'updatedAt', 'deletedAt', 'userId', '__typename', '__proto__', 'primary', 'optedOutAt'].indexOf(commObjKey) === -1) {
                    const csvFieldName = camelToSnakeCase(commType + '_' + arrayRowPrefix + '_' + commObjKey);
                    fields[csvFieldName] = commObj[commObjKey];
                }
            });
        }
    }
    return fields;
}

const convertAccountsToRecord = (contactAccountPositions, include) => {
    let fields = {};
    if (!include) return fields;

    for (let cap = 0; cap < contactAccountPositions.length; cap++) {
        const contactAccountPositionObj = contactAccountPositions[cap];

        let arrayRowPrefix = 'account_' + (cap + 1);

        Object.keys(contactAccountPositionObj).forEach((contactAccountPositionObjKey) => {
            if (['createdAt', 'updatedAt', 'deletedAt', 'userId', '__typename', '__proto__'].indexOf(contactAccountPositionObjKey) === -1) {
                if (contactAccountPositionObjKey === 'account') {
                    const accountObj = contactAccountPositionObj[contactAccountPositionObjKey];
                    Object.keys(accountObj).forEach((accountObjKey) => {
                        if (['createdAt', 'updatedAt', 'deletedAt', 'userId', '__typename', '__proto__'].indexOf(contactAccountPositionObjKey) === -1) {
                            const csvFieldName = camelToSnakeCase(arrayRowPrefix + '_' + accountObjKey);
                            fields[csvFieldName] = accountObj[accountObjKey];
                        }
                    });
                } else {
                    const csvFieldName = camelToSnakeCase(arrayRowPrefix + '_' + contactAccountPositionObjKey);
                    fields[csvFieldName] = contactAccountPositionObj[contactAccountPositionObjKey];
                }
            }
        });
    }
    return fields;
}

export const convertExportsToCSV = async (exportObjs, selectedFields) => {
    try {
        let rows = [];
        for (let c = 0; c < exportObjs.length; c++) {
            let exportObj = exportObjs[c];
            let newRow = {}
            Object.keys(exportObj).forEach((exportObjKey) => {
                const exportObjValue = exportObj[exportObjKey];
                const csvFieldName = camelToSnakeCase(exportObjKey);
                if (['createdAt', 'updatedAt', 'deletedAt'].indexOf(exportObjKey) > -1) {
                    if (selectedFields[exportObjKey] && moment('1970-01-01').isBefore(exportObjValue)) newRow[csvFieldName] = moment(exportObjValue).format('MM/DD/YYYY h:mm a');
                } else if (exportObjKey === 'emailAddresses') {
                    const fields = convertArrayToCommRecord('emailAddress', exportObjValue, selectedFields.primaryEmailAddress, selectedFields.otherEmailAddresses);
                    newRow = {
                        ...newRow,
                        ...fields
                    }
                } else if (exportObjKey === 'mailAddresses') {
                    const fields = convertArrayToCommRecord('mailAddress', exportObjValue, selectedFields.primaryMailAddress, selectedFields.otherMailAddresses);
                    newRow = {
                        ...newRow,
                        ...fields
                    }
                } else if (exportObjKey === 'phoneNumbers') {
                    const fields = convertArrayToCommRecord('phoneNumber', exportObjValue, selectedFields.primaryPhoneNumber, selectedFields.otherPhoneNumbers);
                    newRow = {
                        ...newRow,
                        ...fields
                    }
                } else if (exportObjKey === 'contactAccountPositions') {
                    const fields = convertAccountsToRecord(exportObjValue, selectedFields.currentAccounts);
                    newRow = {
                        ...newRow,
                        ...fields
                    }
                } else if (exportObjKey === 'tags') {
                    if (selectedFields['tags']) newRow.tags = exportObjValue.map(tag => tag.tag).join(', ');
                } else if (['userId', '__typename', '__proto__'].indexOf(exportObjKey) === -1) {
                    if (selectedFields[exportObjKey]) newRow[csvFieldName] = exportObjValue;
                }
            })
            rows.push(newRow);
        }

        const csv = new ObjectsToCsv(rows);
        return await csv.toString(true, true);

    } catch (e) {
        console.trace(e);
        return null;
    }
}

export const allStorage = () => {
    var archive = [],
        keys = Object.keys(localStorage),
        i = 0, key;

    // eslint-disable-next-line no-cond-assign
    for (; key = keys[i]; i++) {
        archive.push(key + '=' + localStorage.getItem(key));
    }

    return archive;
}

export const sortedArraysEqual = (a, b) =>
    a.length === b.length &&
    a.every((v, i) => v === b[i]);

